import React from "react";
import { Routes, Route } from "react-router-dom";
import ChangePasswordDetail from "./change-password-detail";

//
const ChangePassword = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<ChangePasswordDetail />} />
         <Route path="/" element={<ChangePasswordDetail />} />
      </Routes>
    </React.Fragment>
  );
};

export default ChangePassword;
